import React, { useState } from "react";
import SignaturePad from 'signature_pad/dist/signature_pad.js';
// reactstrap components
import {
    Button,
    Modal,
    ModalBody,
    Container,
    Row,
    Col,
} from "reactstrap";

// core components
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import TSText from "components/Forms/TSText.js";
import TSSelect from "components/Forms/TSSelect.js";


//function Register() {
const LineRegister = (props) => {
    const [modalConsent, setModalConsent] = React.useState(false);
    const [showSign, setShowSign] = React.useState(false);

    const [errMsg, setErrMsg] = React.useState(false);
    const [modalError, setModalError] = React.useState(false);
    const [modal2, setModal2] = React.useState(false);

    const [LineTrangskin, setLineTrangskin] = useState("");
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [CID, setCID] = useState("");
    const [phone, setPhone] = useState("");
    const [bDay, setbDay] = useState("");
    const [bMonth, setbMonth] = useState("");
    const [bYear, setbYear] = useState("");
    const [icon, setIcon] = useState("far fa-question-circle");

    const [clientWidth, setClientWidth] = useState(0);
    const [clientHeigh, setClientHeigh] = useState(0);
    const [canvas2, setCanvas] = useState(null);
    const [signPad, setSignPad] = useState(null);

    const liffId = (props.match.params.liffId !== undefined) ? props.match.params.liffId : null;
    const liff = window.liff;

    //const liffApp = { tele: '1654063801-PwXBy90W', register: '1654063801-P8KQYgGn', booking: '1654063801-bZdLjP3w' }
    
    var canvas = null;
    var signaturePad = null;

    React.useEffect(() => {

        liff.init({
            liffId: (liffId != null ? liffId : '1654063801-P8KQYgGn')
            //liffId: '1654063801-P8KQYgGn'
        })
            .then(() => {

                if (liff.isLoggedIn()) {

                    liff.getProfile().then(function (profile) {
                        setLineTrangskin(profile.userId);
                    }).catch(function (error) {
                        window.alert('Register Error getting profile: ' + error);
                    });
                }

            }).catch((err) => {

        });

        setClientWidth(window.innerWidth);
        setClientHeigh(window.innerHeight);

        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };
    },[]);

    const handleSign = () => {
        //setShowSign(true);

        canvas = document.getElementById("signature-pad");
        setCanvas(canvas);
        signaturePad = new SignaturePad(canvas);
        /*
        signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
        });
        */

        setSignPad(signaturePad);
    }

    const handleClear = () => {
        signPad.clear();
    }

    const handleSubmit = (evt) => {
        evt.preventDefault();
        var cntErr = 0;
        var birthdate = moment([bYear, bMonth-1, bDay]);

        var errMsg = '';

        if (birthdate.isValid()) {

        }
        else {
            cntErr += 1;
            errMsg = 'กรุณาระบุวันเดือนปีเกิดให้ถูกต้อง';
        }

        
        if (phone == null || phone == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุหมายเลขโทรศัพท์';
        }


        if (CID == null || CID == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุเลขที่บัตรประจำตัวประชาชน';
        }
        else if (CID.length < 13) {
            cntErr += 1;
            errMsg = 'เลขที่บัตรประจำตัวประชาชนไม่ครบ 13 หลัก';
        }

        if (LastName == null || LastName == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุนามสกุล';
        }

        if (FirstName == null || FirstName == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุชื่อ';
        }
     
        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        }
        else {
            setModalConsent(true);
            //setModal2(true);
        }
      
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        const consent = canvas2.toDataURL();
        //console.log(consent)

        var birthdate = moment([bYear, bMonth - 1, bDay]);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
            },
            body: JSON.stringify({
                "lineTrangskin": LineTrangskin,
                "firstName": FirstName,
                "lastName": LastName,
                "idCard": CID,
                "phone": phone,
                "birthDate": birthdate.format('YYYY-MM-DD'),
                "signBase64": consent
            })
        };

      
        fetch('/api/v1/identity/line-register', requestOptions)
            .then(response => response.json())
            .then(
                (result) => {
                    if (liff.isInClient()) {
                        liff.sendMessages([{
                            'type': 'text',
                            'text': '#registered'
                        }]).then(function () {
                            //window.alert('Message sent');
                            liff.closeWindow();
                        }).catch(function (error) {
                            //alert('sending message: ' + error);
                            if (result.isActive == 1) {
                                alert('ลงทะเบียนเรียบร้อยแล้ว HN' + result.hn);
                                const { from } = props.location.state || { from: { pathname: "/tele" } };
                                props.history.push(from);
                            }
                            else {
                                alert('ลงทะเบียนเรียบร้อยแล้ว กรุณากรอกข้อมูลเพิ่มเติม เพื่อเป็นประโยชน์ต่อการรักษา')
                                const { from } = props.location.state || { from: { pathname: "/profile/1654063801-PwXBy90W" } };
                                props.history.push(from);
                            }
                        });

                    } else {
                        alert("not client");
                    }

                },
                (error) => {
                    alert('fetch: ' + error);
                }
            )    
    }


    const handleCID = (val) => {  
        setCID(val)
        let e = val;

        if (e.length === 13) {
            let sum = 0; 
            for (let i = 0; i < 12; i++) {
                sum += parseFloat(e.charAt(i)) * (13 - i);
            }

            if ((11 - sum % 11) % 10 !== parseFloat(e.charAt(12))) {

                setCID('')
                setErrMsg('เลขบัตรประชาชนของคุณไม่ถูกต้องตามหลักทะเบียนราษฎร์');
                setModalError(true);
                //$('#inputid').addClass('has-error');
                //return false;

            } else {

                //$('#inputid').removeClass('has-error');
                //$('#inputid').addClass('has-success');
                //return true;

            }
        }
    }

    var moment = require('moment');
    require('moment/locale/th');

  return (
      <>
          <Modal style={{ margin: '.1rem' }} isOpen={modalConsent} toggle={() => setModalConsent(false)} backdrop={false} keyboard={false} onClosed={() => setShowSign(false)}
              onOpened={handleSign}
          >
          <div className="modal-header justify-content-center">
                  <button
                      className="close"
                      type="button"
                      onClick={() => setModalConsent(false)}
                  >
                      <i className="now-ui-icons ui-1_simple-remove"></i>
                  </button>
                  <h4 className="title title-up">{(!showSign ? "แบบยินยอมการรับบริการ" : "กรุณาลงลายมือชื่อเพื่อยินยอม")}</h4>
          </div>
          <ModalBody>
                  <p style={{ height: '380px', overflow: 'scroll', display: (!showSign ? "block" : "none") }}>
                      วัตถุประสงค์<br />
                      <br />1. เพื่อให้ประชาชน ผู้รับบริการ ทุกพื้นที่สามารถเข้าถึงบริการด้านการให้คำแนะนำด้านสุขภาพวินิจฉัยโรคเบื้องต้น
                      <br />2. เพื่อให้ประชาชนผู้รับบริการสามารถเข้าถึงและบริหารจัดการข้อมูลสุขภาพทางอิเล็กทรอนิกส์ของตนได้
                      <br />3. เพื่อให้ระบบสารสนเทศและบุคลากรที่ได้รับอนุญาตในการรักษาพยาบาลสามารถนำข้อมูลทางอิเล็กทรอนิกส์เพื่อการบริการสุขภาพไปใช้สำหรับการเข้ารับการรักษาของผู้รับบริการ และเป็นข้อมูลสำคัญประกอบการรักษา หรือในกรณีพิเศษอื่นๆ
                      <br />4. เพื่อนำออกเผยแพร่เพื่อเป็นสื่อด้านการศึกษา วิจัย ประชาสัมพันธ์ และพัฒนาระบบบริการทางการแพทย์ เพื่อประโยชน์ในทางราชการของกรมการแพทย์

                     <br /><br />ข้าพเจ้า {FirstName} {LastName} อายุ {moment().year() - bYear} ปี บัตรประจำตัวประชาชนเลขที่ {CID} หมายเลขโทรศัพท์ {phone} ได้รับการอธิบายถึงวัตถุประสงค์ คำชี้แจงปัญหา ข้อสงสัยในประเด็นต่าง ๆ รวมทั้งประโยชน์ และความเสี่ยงจะเกิดขึ้นอย่างละเอียดและเข้าใจดีแล้วในกรณียินยอม
                     <br /><br />โดยข้าพเจ้า ยินยอมให้โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้จังหวัดตรัง จัดเก็บข้อมูลส่วนบุคคล ข้อมูลด้านสุขภาพ การวินิจฉัยโรค การรักษา บันทึกภาพนิ่ง ภาพเคลื่อนไหว และเสียง เพื่อนำไปใช้ประโยชน์ตามวัตถุประสงค์ที่ข้างต้น
                     <br /><br />กรณีตรวจรักษาผ่านระบบทางไกล (Telemedicine) มีความประสงค์จะเข้าร่วมรับบริการตรวจรักษาผ่านระบบทางไกล(Telemedicine) การรับยาต่อเนื่องและจัดส่งยาทางไปรษณีย์โดยมีรายละเอียดค่าบริการดังนี้
                     <br />1. ค่าดำเนินการและการจัดส่งยาทางไปรษณีย์  90 บาท สำหรับผู้ป่วยทุกสิทธิ ยกเว้นสิทธิประกันสุขภาพถ้วนหน้า ชำระ 40 บาท
                     <br />2. ค่าใช้จ่ายอื่นๆ เช่น ค่าบริการทางการแพทย์ ค่ายานอกบัญชี และเวชภัณฑ์อื่นๆ ที่เบิกไม่ได้  <br />

                      <br /><br />ข้าพเจ้ามีสิทธิที่จะบอกเลิกการยินยอม เมื่อใดก็ได้ ทั้งนี้ การยินยอมหรือไม่ยินยอม และการบอกดังกล่าว จะไม่มีผลต่อการรักษาโรคที่ข้าพเจ้าพึงได้รับต่อไป โดยการบอกเลิกจะมีผลต่อการผลิตสื่อในครั้งหน้า และไม่มีผลต่อสื่อที่ทำไปแล้วก่อนที่จะได้รับหนังสือบอกเลิกการยินยอม
                     <br />
                      {/*
                      มีความประสงค์จะเข้าร่วมรับบริการส่งยาทางไปรษณีย์  โดยมีรายละเอียดดังนี้<br />
                      1. การตรวจรักษาระบบทางไกล (Telemedicine) ให้สถานพยาบาล จัดเก็บ/เปิดเผยข้อมูล/ส่งข้อมูล ทางอิเล็กทรอนิกส์เพื่อการรักษาพยาบาล  <br />
                      2. ค่าดำเนินการและการจัดส่งยาทางไปรษณีย์  90 บาท สำหรับผู้ป่วยทุกสิทธิ ยกเว้นสิทธิประกันสุขภาพถ้วนหน้า ชำระ 40 บาท <br /> 
                      3. ค่าใช้จ่ายอื่นๆ เช่น ค่าบริการทางการแพทย์ ค่ายานอกบัญชี และเวชภัณฑ์อื่นๆ ที่เบิกไม่ได้  <br />
                     */}
                      <br /><br />ข้าพเจ้าอ่านและเข้าใจ จึงยอมรับเงื่อนไขของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ข้าพเจ้าจึงลงนามยินยอม

                  </p>
                  <div style={{
                      border: 'solid black 1px', margin:'0 -25px 0 -25px', display: (showSign ? "block" : "none")}} >
                      <canvas id="signature-pad" className="signature-pad" width={clientWidth-3} height={250}></canvas>
                  </div>

          </ModalBody>
          <div className="modal-footer">
                  <Button color="danger" type="button" onClick={() => setModalConsent(false)}>
                      ไม่ยินยอม
                  </Button>

                  <Button color="danger" color="warning" type="button" onClick={handleClear} style={{ display: (showSign ? "block" : "none") }} >
                      เซ็นใหม่
                  </Button>

                  <Button
                      color="info"
                      type="button"
                      //onClick={handleSign}
                      onClick={()=>setShowSign(true)}
                      style={{ display: (!showSign ? "block" : "none" )}}
                  >
                      เซ็นชื่อ
                  </Button>
                  <Button
                      color="info"
                      type="button"
                      //onClick={() => setModalConsent(false)}
                      //onClick={handleConfirm}
                      onClick={() => setModal2(true)}
                      style={{ display: (showSign ? "block" : "none") }}
                  >
                      ยินยอม
                  </Button>
          </div>
          </Modal>

          {/*
      <Modal isOpen={modalSign} toggle={() => setModalSign(false)}>
          <div className="modal-header justify-content-center">
                  <button
                      className="close"
                      type="button"
                      onClick={() => setModalSign(false)}
                  >
                      <i className="now-ui-icons ui-1_simple-remove"></i>
                  </button>
                  <h4 className="title title-up">แบบยินยอมการรับบริการ</h4>
          </div>
          <ModalBody>
                  <p style={{ height: '380px', overflow: 'scroll' }}>
                      1. ข้าพเจ้า {FirstName} {LastName} อายุ {moment().year() - bYear} ปี บัตรประจำตัวประชาชนเลขที่ {CID} หมายเลขโทรศัพท์ {phone} <br />
                      2. ข้าพเจ้าเป็นผู้ป่วย/ญาติ มีความประสงค์ที่จะเข้าร่วมโครงการ “รักษาทางไกล และการจัดส่งยาทางไปรษณีย์” 
                      ซึ่งวัตถุประสงค์ของโครงการนี้คือ เพื่อลดความแออัดของผู้มารับบริการ 
                      ลดระยะเวลาในการรอรับยาของผู้ป่วยนอก และเพิ่มความพึงพอใจให้แก่ผู้มารับบริการมากขึ้น 
                      โดยข้าพเจ้าได้อ่าน/รับคำอธิบายเกี่ยวกับวัตถุประสงค์ และรูปแบบวิธีดำเนินโครงการจนมีความเข้าใจดีแล้วทุกประการ 
                      ด้วยข้าพเจ้าเห็นประโยชน์ที่จะได้รับจากการเข้าร่วมโครงการฯ จึงได้ลงนามใบยินยอมนี้ด้วยความเต็มใจ 
                      พร้อมทั้งยินดีชำระเงินจำนวน 90 บาท เพื่อเป็นค่าใช้จ่ายในการจัดส่งยาทางไปรษณีย์ <br />
                      3. ข้าพเจ้ายินยอมให้ สถานพยาบาล เปิดเผยข้อมูล / ส่งข้อมูล ทางอิเล็กทรอนิกส์ (สำเนาข้อมูล )
                      เพื่อการรักษา พยาบาลแก่ผู้ประกอบวิชาชีพด้านสาธารณสุข (บุคลากรที่ได้รับอนุญาตในการรักษาพยาบาล ) 
                      และสถานพยาบาลที่ให้บริการรักษาได้
                  </p>
          </ModalBody>
          <div className="modal-footer">
                  <Button color="danger" type="button">
                      ไม่ยินยอม
                  </Button>
                  <Button
                      color="info"
                      type="button"
                      onClick={() => setModalSign(false)}
                  >
                      ยินยอม
                  </Button>
          </div>
          </Modal>
          */}
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader />
              <div className="main">
                  {/*
                   <div className="section">
                      <Container>
                          <Row>
                              <Col md="2">
                              </Col>
                              <Col md="8">
                                  <div className="hero-images-container" style={{ marginTop: '-20vh', maxWidth:'680px'}}>
                                      <img
                                          alt="..."
                                          src={require("assets/img/ts_logo_xl.png")}
                                      ></img>
                                  </div>
                              </Col>
                              <Col md="2">
                              </Col>
                          </Row>
                      </Container>
                  </div>
                   */}  
            </div>
        
            <div className="section section-contact-us text-left" style={{ padding: '0' }}>
                  <Container>
                      <Row>
                          <Col lg="12" className="text-center">
                              <Button color="info" block onClick={()=>window.location.href = 'https://imauth.bora.dopa.go.th/api/v2/oauth2/auth/?response_type=code&client_id=cDBEU21uTWI0eVIwdktlbzJGcXlQYzlWMWNqMzFyYzk&redirect_uri=https://liff.line.me/1654063801-M0v4BJm2&scope=pid%20title%20given_name%20family_name%20title_en%20given_name_en%20family_name_en%20gender%20birthdate%20address&state=1s3k7i5n5'}>

                                  <img
                                      src={require("assets/img/thaidlogo.png")}
                                      alt="ThaiD Icon"
                                      style={{ width: '30px', marginRight: '10px' }}
                                  />
                                      <span style={{ fontSize: 'large' }}>ลงทะเบียนผ่าน ThaiD</span>

                              </Button>
                          </Col>
                      </Row>
                      <h2 className="title text-center">ลงทะเบียนข้อมูลเพื่อเข้ารับบริการ</h2>
                      <p className="description"></p>
                      <Row>
                          {/*
                          <Col md="2">
                              <TSSelect placeholder="คำนำหน้า" url="/api/title" onChange={e => setTitle(e.target.value)} />
                          </Col>
                         
                         
                          <Col md="12">
                              <TSText placeholder="Line Token" value={LineTrangskin}  onChange={e => setLineTrangskin(e.target.value)} />
                          </Col>
                           */
                           }
                          <Col md="3">
                              <TSText placeholder="ชื่อ" onChange={e => setFirstName(e.target.value)} icon="fas fa-user-edit fa-2x"/>
                          </Col>
                          <Col md="3">
                              <TSText placeholder="สกุล" onChange={e => setLastName(e.target.value)} icon="fas fa-user-edit fa-2x"/>
                          </Col>
                          <Col md="3">
                              <TSText type="tel" placeholder="เลขที่บัตรประจำตัวประชาชน" value={CID} maxLength="13" onChange={e => handleCID(e.target.value)/*setCID(e.target.value)*/} icon="far fa-id-card fa-2x" />
                          </Col>
                          <Col md="3">
                              <TSText maxLength="10" type="tel" placeholder="หมายเลขโทรศัพท์" value={phone} onChange={e => setPhone(e.target.value)} icon="fas fa-mobile-alt fa-2x"/>
                          </Col>
                      </Row>

                      <Row>
                          <Col lg="12" className="text-left">                        
                              <h4>วัน เดือน ปี เกิด</h4>
                          </Col>
                          <Col xs="3" lg="4">
                              <TSSelect placeholder="วัน" isDefault={true} fixData="day" onChange={e => setbDay(e)} />

                          </Col>
                          <Col xs="5" lg="4">
                              <TSSelect placeholder="เดือน" isDefault={true} fixData="month" onChange={e => setbMonth(e)} />
                          </Col>
                          <Col  xs="4" lg="4">
                              <TSSelect placeholder="ปี" isDefault={true} fixData="year" onChange={e => setbYear(e)} />
                          </Col>

                      </Row>
                      <Row>
                          <Col className="text-center ml-auto mr-auto" lg="6" md="8">
                            <Button
                                  block
                                  className="btn-round"
                                  color="info"
                                  href="#pablo"
                                  size="lg"
                                  style={{ fontSize: '1.2em', display: (!showSign ? "block" : "none") }}
                                  onClick={handleSubmit}
                              >
                                  ลงทะเบียน
                             </Button>

                              {/* Confirm */}
                              <Modal
                                  modalClassName="modal-mini modal-info"
                                  toggle={() => setModal2(false)}
                                  isOpen={modal2}
                              >
                                  <div className="modal-header justify-content-center">
                                      <div className="modal-profile">
                                          <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                      </div>
                                  </div>
                                  <ModalBody>
                                      
                                      <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล":"กำลังตรวจสอบข้อมูล"}</p>
                                      <p>  </p>
                                  </ModalBody>
                                  <div className="modal-footer">
                                      <Button
                                          className="btn-neutral"
                                          color="link"
                                          type="button"
                                          onClick={() => setModal2(false)}
                                      >
                                          ยกเลิก
                                      </Button>

                                      <Button
                                          className="btn-neutral"
                                          color="link"
                                          type="button"
                                          onClick={handleConfirm}
                                          disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"} 
                                          //onClick={() => setModal2(false)}
                                      >
                                          ยืนยัน
                                      </Button>



                                  </div>
                              </Modal>


                              {/* Error */}
                              <Modal
                                  modalClassName="modal-mini modal-danger"
                                  toggle={() => setModalError(false)}
                                  isOpen={modalError}
                              >
                                  <div className="modal-header justify-content-center">
                                      <div className="modal-profile">
                                          <i className="fa fa-times" style={{ color: 'red', fontSize: '2em'}}></i>
                                      </div>
                                  </div>
                                  <ModalBody>
                                      <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                      <p> {errMsg} </p>
                                  </ModalBody>
                                  <div className="modal-footer justify-content-center">
                                      <Button
                                          className="btn-neutral"
                                          color="neutral"
                                          type="button"
                                          onClick={() => setModalError(false)}
                                      >
                                          ตกลง
                                      </Button>
                                  </div>
                              </Modal>
                            </Col>
                      </Row>

                      
                                
                  </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default LineRegister;
